import styled, { css } from 'styled-components';
import { MenuButton } from '../Menu';
import { navTheme } from '../../theme/nav-theme';
export const StyledMenuButton = styled(MenuButton)(({
  theme: _theme
}) => {
  const theme = _theme;
  return css(["border-radius:50%;width:32px;height:32px;border:1px solid ", ";align-self:center;justify-self:center;align-content:center;justify-content:center;display:flex;background:transparent;flex-wrap:wrap;&:hover{background:", ";border:1px solid ", ";}& > svg{display:flex;fill:", ";}"], navTheme(theme).navBorderPrimary, navTheme(theme).navBgSecondary, navTheme(theme).navBorderSecondary, navTheme(theme).navIconPrimary);
});
StyledMenuButton.displayName = 'StyledMenuButton';